import { StrictLocalizeFunction } from "../localization/localize";

export const primaryCallingCodes = (strictLocalize: StrictLocalizeFunction) => [
  [
    strictLocalize({
      id: "zwvKKX",
      defaultMessage: "United States of America",
      description: { text: "Country name" },
    }),
    "+1",
  ],
  [
    strictLocalize({
      id: "Y43l6H",
      defaultMessage: "Canada",
      description: { text: "Country name" },
    }),
    "+1",
  ],
  [
    strictLocalize({
      id: "uERgVc",
      defaultMessage: "United Kingdom",
      description: { text: "Country name" },
    }),
    "+44",
  ],
];

export const secondaryCallingCodes = (
  strictLocalize: StrictLocalizeFunction
) => [
  [
    strictLocalize({
      id: "HlpkCb",
      defaultMessage: "Netherlands",
      description: { text: "Country name" },
    }),
    "+31",
  ],
  [
    strictLocalize({
      id: "TMfPFS",
      defaultMessage: "France",
      description: { text: "Country name" },
    }),
    "+33",
  ],
  [
    strictLocalize({
      id: "Jg9P3N",
      defaultMessage: "Germany",
      description: { text: "Country name" },
    }),
    "+49",
  ],
  [
    strictLocalize({
      id: "2cGE7a",
      defaultMessage: "Italy",
      description: { text: "Country name" },
    }),
    "+39",
  ],
  [
    strictLocalize({
      id: "73A2s8",
      defaultMessage: "Spain",
      description: { text: "Country name" },
    }),
    "+34",
  ],
  [
    strictLocalize({
      id: "n3QQnp",
      defaultMessage: "Austria",
      description: { text: "Country name" },
    }),
    "+43",
  ],
  [
    strictLocalize({
      id: "SGul1d",
      defaultMessage: "Belgium",
      description: { text: "Country name" },
    }),
    "+32",
  ],
  [
    strictLocalize({
      id: "KyFlH3",
      defaultMessage: "Ireland",
      description: { text: "Country name" },
    }),
    "+353",
  ],
  [
    strictLocalize({
      id: "RoyikP",
      defaultMessage: "Luxembourg",
      description: { text: "Country name" },
    }),
    "+352",
  ],
  [
    strictLocalize({
      id: "wi3n+L",
      defaultMessage: "Australia",
      description: { text: "Country name" },
    }),
    "+61",
  ],
  [
    strictLocalize({
      id: "krN2E7",
      defaultMessage: "Finland",
      description: { text: "Country name" },
    }),
    "+358",
  ],
  [
    strictLocalize({
      id: "wwP+59",
      defaultMessage: "Denmark",
      description: { text: "Country name" },
    }),
    "+45",
  ],
  [
    strictLocalize({
      id: "/iWlKM",
      defaultMessage: "Sweden",
      description: { text: "Country name" },
    }),
    "+46",
  ],
  [
    strictLocalize({
      id: "M3MKYO",
      defaultMessage: "Norway",
      description: { text: "Country name" },
    }),
    "+47",
  ],
  [
    strictLocalize({
      id: "IhJIY6",
      defaultMessage: "Switzerland",
      description: { text: "Country name" },
    }),
    "+41",
  ],
  [
    strictLocalize({
      id: "Pn2q0M",
      defaultMessage: "Northern Ireland",
      description: { text: "Country name" },
    }),
    "+44 28",
  ],
  [
    strictLocalize({
      id: "HEtxVV",
      defaultMessage: "Portugal",
      description: { text: "Country name" },
    }),
    "+351",
  ],
];

export const callingCodes = (strictLocalize: StrictLocalizeFunction) => [
  [
    strictLocalize({
      id: "QR3g6K",
      defaultMessage: "Zimbabwe",
      description: { text: "Country name" },
    }),
    "+63",
  ],
  [
    strictLocalize({
      id: "p52X6h",
      defaultMessage: "Bahamas",
      description: { text: "Country name" },
    }),
    "+1 242",
  ],
  [
    strictLocalize({
      id: "nnXtJv",
      defaultMessage: "Barbados",
      description: { text: "Country name" },
    }),
    "+1 246",
  ],
  [
    strictLocalize({
      id: "/Xv8iQ",
      defaultMessage: "Anguilla",
      description: { text: "Country name" },
    }),
    "+1 264",
  ],
  [
    strictLocalize({
      id: "NHAJW1",
      defaultMessage: "Antigua and Barbuda",
      description: { text: "Country name" },
    }),
    "+1 268",
  ],
  [
    strictLocalize({
      id: "W5rpKU",
      defaultMessage: "Barbuda",
      description: { text: "Country name" },
    }),
    "+1 268",
  ],
  [
    strictLocalize({
      id: "ozel3F",
      defaultMessage: "British Virgin Islands",
      description: { text: "Country name" },
    }),
    "+1 284",
  ],
  [
    strictLocalize({
      id: "dTL/Xq",
      defaultMessage: "US Virgin Islands",
      description: { text: "Country name" },
    }),
    "+1 340",
  ],
  [
    strictLocalize({
      id: "pUwxTl",
      defaultMessage: "Cayman Islands",
      description: { text: "Country name" },
    }),
    "+1 345",
  ],
  [
    strictLocalize({
      id: "pO16Lq",
      defaultMessage: "Bermuda",
      description: { text: "Country name" },
    }),
    "+1 441",
  ],
  [
    strictLocalize({
      id: "hwFE5k",
      defaultMessage: "Grenada",
      description: { text: "Country name" },
    }),
    "+1 473",
  ],
  [
    strictLocalize({
      id: "/VMImV",
      defaultMessage: "Turks and Caicos Islands",
      description: { text: "Country name" },
    }),
    "+1 649",
  ],
  [
    strictLocalize({
      id: "22YmQ7",
      defaultMessage: "Montserrat",
      description: { text: "Country name" },
    }),
    "+1 664",
  ],
  [
    strictLocalize({
      id: "Ywp73c",
      defaultMessage: "Northern Mariana Islands",
      description: { text: "Country name" },
    }),
    "+1 670",
  ],
  [
    strictLocalize({
      id: "H548hZ",
      defaultMessage: "Guam",
      description: { text: "Country name" },
    }),
    "+1 671",
  ],
  [
    strictLocalize({
      id: "RuWNAO",
      defaultMessage: "American Samoa",
      description: { text: "Country name" },
    }),
    "+1 684",
  ],
  [
    strictLocalize({
      id: "cb9bVc",
      defaultMessage: "Sint Maarten (Netherlands)",
      description: { text: "Country name" },
    }),
    "+1 721",
  ],
  [
    strictLocalize({
      id: "kaHMwy",
      defaultMessage: "Saint Lucia",
      description: { text: "Country name" },
    }),
    "+1 758",
  ],
  [
    strictLocalize({
      id: "TwUQfn",
      defaultMessage: "Dominica",
      description: { text: "Country name" },
    }),
    "+1 767",
  ],
  [
    strictLocalize({
      id: "wXLHwk",
      defaultMessage: "Saint Vincent and the Grenadines",
      description: { text: "Country name" },
    }),
    "+1 784",
  ],
  [
    strictLocalize({
      id: "lb/Sp4",
      defaultMessage: "Puerto Rico",
      description: { text: "Country name" },
    }),
    "+1 787",
  ],
  [
    strictLocalize({
      id: "lb/Sp4",
      defaultMessage: "Puerto Rico",
      description: { text: "Country name" },
    }),
    "+1 939",
  ],
  [
    strictLocalize({
      id: "Jm4p9E",
      defaultMessage: "Midway Island, USA",
      description: { text: "Country name" },
    }),
    "+1 808",
  ],
  [
    strictLocalize({
      id: "skW1o1",
      defaultMessage: "Wake Island, USA",
      description: { text: "Country name" },
    }),
    "+1 808",
  ],
  [
    strictLocalize({
      id: "R9KcDS",
      defaultMessage: "Dominican Republic",
      description: { text: "Country name" },
    }),
    "+1 809",
  ],
  [
    strictLocalize({
      id: "R9KcDS",
      defaultMessage: "Dominican Republic",
      description: { text: "Country name" },
    }),
    "+1 829",
  ],
  [
    strictLocalize({
      id: "R9KcDS",
      defaultMessage: "Dominican Republic",
      description: { text: "Country name" },
    }),
    "+1 849",
  ],
  [
    strictLocalize({
      id: "j8Q6pf",
      defaultMessage: "Trinidad and Tobago",
      description: { text: "Country name" },
    }),
    "+1 868",
  ],
  [
    strictLocalize({
      id: "3mO0+C",
      defaultMessage: "Nevis",
      description: { text: "Country name" },
    }),
    "+1 869",
  ],
  [
    strictLocalize({
      id: "Lr71H9",
      defaultMessage: "Saint Kitts and Nevis",
      description: { text: "Country name" },
    }),
    "+1 869",
  ],
  [
    strictLocalize({
      id: "mnQosS",
      defaultMessage: "Jamaica",
      description: { text: "Country name" },
    }),
    "+1 876",
  ],
  [
    strictLocalize({
      id: "8Km2x9",
      defaultMessage: "Egypt",
      description: { text: "Country name" },
    }),
    "+20",
  ],
  [
    strictLocalize({
      id: "YcgnTs",
      defaultMessage: "South Sudan",
      description: { text: "Country name" },
    }),
    "+211",
  ],
  [
    strictLocalize({
      id: "Ahm3S5",
      defaultMessage: "Morocco",
      description: { text: "Country name" },
    }),
    "+212",
  ],
  [
    strictLocalize({
      id: "2KJJ7X",
      defaultMessage: "Algeria",
      description: { text: "Country name" },
    }),
    "+213",
  ],
  [
    strictLocalize({
      id: "OzhbZp",
      defaultMessage: "Tunisia",
      description: { text: "Country name" },
    }),
    "+216",
  ],
  [
    strictLocalize({
      id: "duL7f1",
      defaultMessage: "Libya",
      description: { text: "Country name" },
    }),
    "+218",
  ],
  [
    strictLocalize({
      id: "s2Sy+v",
      defaultMessage: "Gambia",
      description: { text: "Country name" },
    }),
    "+220",
  ],
  [
    strictLocalize({
      id: "p37RgC",
      defaultMessage: "Senegal",
      description: { text: "Country name" },
    }),
    "+221",
  ],
  [
    strictLocalize({
      id: "VhIhYa",
      defaultMessage: "Mauritania",
      description: { text: "Country name" },
    }),
    "+222",
  ],
  [
    strictLocalize({
      id: "xRkAYP",
      defaultMessage: "Mali",
      description: { text: "Country name" },
    }),
    "+223",
  ],
  [
    strictLocalize({
      id: "+mu5pQ",
      defaultMessage: "Guinea",
      description: { text: "Country name" },
    }),
    "+224",
  ],
  [
    strictLocalize({
      id: "u+3lQz",
      defaultMessage: "Ivory Coast",
      description: { text: "Country name" },
    }),
    "+225",
  ],
  [
    strictLocalize({
      id: "SC1iNB",
      defaultMessage: "Burkina Faso",
      description: { text: "Country name" },
    }),
    "+226",
  ],
  [
    strictLocalize({
      id: "6z1tLM",
      defaultMessage: "Niger",
      description: { text: "Country name" },
    }),
    "+227",
  ],
  [
    strictLocalize({
      id: "mf8QCj",
      defaultMessage: "Togo",
      description: { text: "Country name" },
    }),
    "+228",
  ],
  [
    strictLocalize({
      id: "qIodyS",
      defaultMessage: "Benin",
      description: { text: "Country name" },
    }),
    "+229",
  ],
  [
    strictLocalize({
      id: "UFg4RN",
      defaultMessage: "Mauritius",
      description: { text: "Country name" },
    }),
    "+230",
  ],
  [
    strictLocalize({
      id: "cJ1AN2",
      defaultMessage: "Liberia",
      description: { text: "Country name" },
    }),
    "+231",
  ],
  [
    strictLocalize({
      id: "HJ6rPH",
      defaultMessage: "Sierra Leone",
      description: { text: "Country name" },
    }),
    "+232",
  ],
  [
    strictLocalize({
      id: "sacbC3",
      defaultMessage: "Ghana",
      description: { text: "Country name" },
    }),
    "+233",
  ],
  [
    strictLocalize({
      id: "baaOlU",
      defaultMessage: "Nigeria",
      description: { text: "Country name" },
    }),
    "+234",
  ],
  [
    strictLocalize({
      id: "vocmjG",
      defaultMessage: "Chad",
      description: { text: "Country name" },
    }),
    "+235",
  ],
  [
    strictLocalize({
      id: "JuPwYl",
      defaultMessage: "Central African Republic",
      description: { text: "Country name" },
    }),
    "+236",
  ],
  [
    strictLocalize({
      id: "y9+KMd",
      defaultMessage: "Cameroon",
      description: { text: "Country name" },
    }),
    "+237",
  ],
  [
    strictLocalize({
      id: "3dwDVs",
      defaultMessage: "Cape Verde",
      description: { text: "Country name" },
    }),
    "+238",
  ],
  [
    strictLocalize({
      id: "z4xhoj",
      defaultMessage: "São Tomé and Príncipe",
      description: { text: "Country name" },
    }),
    "+239",
  ],
  [
    strictLocalize({
      id: "MrUUgI",
      defaultMessage: "Equatorial Guinea",
      description: { text: "Country name" },
    }),
    "+240",
  ],
  [
    strictLocalize({
      id: "r4x+33",
      defaultMessage: "Gabon",
      description: { text: "Country name" },
    }),
    "+241",
  ],
  [
    strictLocalize({
      id: "hP/CI+",
      defaultMessage: "Congo",
      description: { text: "Country name" },
    }),
    "+242",
  ],
  [
    strictLocalize({
      id: "/J34Ev",
      defaultMessage: "Congo, Democratic Republic of the (Zaire)",
      description: { text: "Country name" },
    }),
    "+243",
  ],
  [
    strictLocalize({
      id: "vF3mkm",
      defaultMessage: "Angola",
      description: { text: "Country name" },
    }),
    "+244",
  ],
  [
    strictLocalize({
      id: "wZ3yaX",
      defaultMessage: "Guinea-Bissau",
      description: { text: "Country name" },
    }),
    "+245",
  ],
  [
    strictLocalize({
      id: "4zu/yh",
      defaultMessage: "British Indian Ocean Territory",
      description: { text: "Country name" },
    }),
    "+246",
  ],
  [
    strictLocalize({
      id: "yrMQcv",
      defaultMessage: "Diego Garcia",
      description: { text: "Country name" },
    }),
    "+246",
  ],
  [
    strictLocalize({
      id: "6f9u71",
      defaultMessage: "Ascension",
      description: { text: "Country name" },
    }),
    "+247",
  ],
  [
    strictLocalize({
      id: "IsFZWA",
      defaultMessage: "Seychelles",
      description: { text: "Country name" },
    }),
    "+248",
  ],
  [
    strictLocalize({
      id: "eaJbCT",
      defaultMessage: "Sudan",
      description: { text: "Country name" },
    }),
    "+249",
  ],
  [
    strictLocalize({
      id: "M5Kh/B",
      defaultMessage: "Rwanda",
      description: { text: "Country name" },
    }),
    "+250",
  ],
  [
    strictLocalize({
      id: "/w8ktd",
      defaultMessage: "Ethiopia",
      description: { text: "Country name" },
    }),
    "+251",
  ],
  [
    strictLocalize({
      id: "AJjHB9",
      defaultMessage: "Somalia",
      description: { text: "Country name" },
    }),
    "+252",
  ],
  [
    strictLocalize({
      id: "CY07jY",
      defaultMessage: "Djibouti",
      description: { text: "Country name" },
    }),
    "+253",
  ],
  [
    strictLocalize({
      id: "YUI/xi",
      defaultMessage: "Kenya",
      description: { text: "Country name" },
    }),
    "+254",
  ],
  [
    strictLocalize({
      id: "zAO9fE",
      defaultMessage: "Tanzania",
      description: { text: "Country name" },
    }),
    "+255",
  ],
  [
    strictLocalize({
      id: "lmOjX9",
      defaultMessage: "Zanzibar",
      description: { text: "Country name" },
    }),
    "+255 24",
  ],
  [
    strictLocalize({
      id: "lX0oob",
      defaultMessage: "Uganda",
      description: { text: "Country name" },
    }),
    "+256",
  ],
  [
    strictLocalize({
      id: "aqoo9+",
      defaultMessage: "Burundi",
      description: { text: "Country name" },
    }),
    "+257",
  ],
  [
    strictLocalize({
      id: "iB8yfD",
      defaultMessage: "Mozambique",
      description: { text: "Country name" },
    }),
    "+258",
  ],
  [
    strictLocalize({
      id: "xlbusQ",
      defaultMessage: "Zambia",
      description: { text: "Country name" },
    }),
    "+260",
  ],
  [
    strictLocalize({
      id: "CqTXi8",
      defaultMessage: "Madagascar",
      description: { text: "Country name" },
    }),
    "+261",
  ],
  [
    strictLocalize({
      id: "OFvw8Y",
      defaultMessage: "Réunion",
      description: { text: "Country name" },
    }),
    "+262",
  ],
  [
    strictLocalize({
      id: "2w8doT",
      defaultMessage: "Mayotte",
      description: { text: "Country name" },
    }),
    "+262 269",
  ],
  [
    strictLocalize({
      id: "2w8doT",
      defaultMessage: "Mayotte",
      description: { text: "Country name" },
    }),
    "+262 639",
  ],
  [
    strictLocalize({
      id: "m9VosY",
      defaultMessage: "Namibia",
      description: { text: "Country name" },
    }),
    "+264",
  ],
  [
    strictLocalize({
      id: "D/jODG",
      defaultMessage: "Malawi",
      description: { text: "Country name" },
    }),
    "+265",
  ],
  [
    strictLocalize({
      id: "Be+iGc",
      defaultMessage: "Lesotho",
      description: { text: "Country name" },
    }),
    "+266",
  ],
  [
    strictLocalize({
      id: "ufWv10",
      defaultMessage: "Botswana",
      description: { text: "Country name" },
    }),
    "+267",
  ],
  [
    strictLocalize({
      id: "grUzfq",
      defaultMessage: "eSwatini",
      description: { text: "Country name" },
    }),
    "+268",
  ],
  [
    strictLocalize({
      id: "AurtzJ",
      defaultMessage: "Comoros",
      description: { text: "Country name" },
    }),
    "+269",
  ],
  [
    strictLocalize({
      id: "F4JAu9",
      defaultMessage: "South Africa",
      description: { text: "Country name" },
    }),
    "+27",
  ],
  [
    strictLocalize({
      id: "nacNQW",
      defaultMessage: "Saint Helena",
      description: { text: "Country name" },
    }),
    "+290",
  ],
  [
    strictLocalize({
      id: "sjTYu4",
      defaultMessage: "Tristan da Cunha",
      description: { text: "Country name" },
    }),
    "+290 8",
  ],
  [
    strictLocalize({
      id: "rZ4Na4",
      defaultMessage: "Eritrea",
      description: { text: "Country name" },
    }),
    "+291",
  ],
  [
    strictLocalize({
      id: "CWtTCF",
      defaultMessage: "Aruba",
      description: { text: "Country name" },
    }),
    "+297",
  ],
  [
    strictLocalize({
      id: "vYAqto",
      defaultMessage: "Faroe Islands",
      description: { text: "Country name" },
    }),
    "+298",
  ],
  [
    strictLocalize({
      id: "wGMus1",
      defaultMessage: "Greenland",
      description: { text: "Country name" },
    }),
    "+299",
  ],
  [
    strictLocalize({
      id: "dFXNeW",
      defaultMessage: "Greece",
      description: { text: "Country name" },
    }),
    "+30",
  ],
  [
    strictLocalize({
      id: "M75o+d",
      defaultMessage: "Gibraltar",
      description: { text: "Country name" },
    }),
    "+350",
  ],

  [
    strictLocalize({
      id: "gsrojz",
      defaultMessage: "Iceland",
      description: { text: "Country name" },
    }),
    "+354",
  ],
  [
    strictLocalize({
      id: "Gujw38",
      defaultMessage: "Albania",
      description: { text: "Country name" },
    }),
    "+355",
  ],
  [
    strictLocalize({
      id: "w+9rqk",
      defaultMessage: "Malta",
      description: { text: "Country name" },
    }),
    "+356",
  ],
  [
    strictLocalize({
      id: "74C1kJ",
      defaultMessage: "Cyprus",
      description: { text: "Country name" },
    }),
    "+357",
  ],

  [
    strictLocalize({
      id: "vo6xQo",
      defaultMessage: "Åland Islands",
      description: { text: "Country name" },
    }),
    "+358 18",
  ],
  [
    strictLocalize({
      id: "dL0aUo",
      defaultMessage: "Bulgaria",
      description: { text: "Country name" },
    }),
    "+359",
  ],
  [
    strictLocalize({
      id: "vAhBtw",
      defaultMessage: "Hungary",
      description: { text: "Country name" },
    }),
    "+36",
  ],
  [
    strictLocalize({
      id: "RwSpZ1",
      defaultMessage: "Lithuania",
      description: { text: "Country name" },
    }),
    "+370",
  ],
  [
    strictLocalize({
      id: "TAHmAF",
      defaultMessage: "Latvia",
      description: { text: "Country name" },
    }),
    "+371",
  ],
  [
    strictLocalize({
      id: "a+D4op",
      defaultMessage: "Estonia",
      description: { text: "Country name" },
    }),
    "+372",
  ],
  [
    strictLocalize({
      id: "aJcUCW",
      defaultMessage: "Moldova",
      description: { text: "Country name" },
    }),
    "+373",
  ],
  [
    strictLocalize({
      id: "BaTSAs",
      defaultMessage: "Transnistria",
      description: { text: "Country name" },
    }),
    "+373 2",
  ],
  [
    strictLocalize({
      id: "BaTSAs",
      defaultMessage: "Transnistria",
      description: { text: "Country name" },
    }),
    "+373 5",
  ],
  [
    strictLocalize({
      id: "+ioUue",
      defaultMessage: "Armenia",
      description: { text: "Country name" },
    }),
    "+374",
  ],
  [
    strictLocalize({
      id: "QyerFb",
      defaultMessage: "Nagorno-Karabakh",
      description: { text: "Country name" },
    }),
    "+374 47",
  ],
  [
    strictLocalize({
      id: "QyerFb",
      defaultMessage: "Nagorno-Karabakh",
      description: { text: "Country name" },
    }),
    "+374 97",
  ],
  [
    strictLocalize({
      id: "2kZkX/",
      defaultMessage: "Belarus",
      description: { text: "Country name" },
    }),
    "+375",
  ],
  [
    strictLocalize({
      id: "93njYI",
      defaultMessage: "Andorra",
      description: { text: "Country name" },
    }),
    "+376",
  ],
  [
    strictLocalize({
      id: "/BdZr9",
      defaultMessage: "Monaco",
      description: { text: "Country name" },
    }),
    "+377",
  ],
  [
    strictLocalize({
      id: "sX5Nh2",
      defaultMessage: "San Marino",
      description: { text: "Country name" },
    }),
    "+378",
  ],
  [
    strictLocalize({
      id: "LbrKZt",
      defaultMessage: "Ukraine",
      description: { text: "Country name" },
    }),
    "+380",
  ],
  [
    strictLocalize({
      id: "hg7dgx",
      defaultMessage: "Serbia",
      description: { text: "Country name" },
    }),
    "+381",
  ],
  [
    strictLocalize({
      id: "0pMo08",
      defaultMessage: "Montenegro",
      description: { text: "Country name" },
    }),
    "+382",
  ],
  [
    strictLocalize({
      id: "zZZv+D",
      defaultMessage: "Kosovo",
      description: { text: "Country name" },
    }),
    "+383",
  ],
  [
    strictLocalize({
      id: "sKVEhc",
      defaultMessage: "Croatia",
      description: { text: "Country name" },
    }),
    "+385",
  ],
  [
    strictLocalize({
      id: "Eb7TBP",
      defaultMessage: "Slovenia",
      description: { text: "Country name" },
    }),
    "+386",
  ],
  [
    strictLocalize({
      id: "Lfkg6l",
      defaultMessage: "Bosnia and Herzegovina",
      description: { text: "Country name" },
    }),
    "+387",
  ],
  [
    strictLocalize({
      id: "wzdorR",
      defaultMessage: "North Macedonia",
      description: { text: "Country name" },
    }),
    "+389",
  ],
  [
    strictLocalize({
      id: "161T2t",
      defaultMessage: "Vatican City",
      description: { text: "Country name" },
    }),
    "+39",
  ],
  [
    strictLocalize({
      id: "txpaaH",
      defaultMessage: "Romania",
      description: { text: "Country name" },
    }),
    "+40",
  ],
  [
    strictLocalize({
      id: "LlNh8P",
      defaultMessage: "Czechia",
      description: { text: "Country name" },
    }),
    "+420",
  ],
  [
    strictLocalize({
      id: "QO0zUl",
      defaultMessage: "Slovakia",
      description: { text: "Country name" },
    }),
    "+421",
  ],
  [
    strictLocalize({
      id: "EBiOjC",
      defaultMessage: "Liechtenstein",
      description: { text: "Country name" },
    }),
    "+423",
  ],

  [
    strictLocalize({
      id: "nGDB07",
      defaultMessage: "Guernsey",
      description: { text: "Country name" },
    }),
    "+44 1481",
  ],
  [
    strictLocalize({
      id: "nGDB07",
      defaultMessage: "Guernsey",
      description: { text: "Country name" },
    }),
    "+44 7781",
  ],
  [
    strictLocalize({
      id: "nGDB07",
      defaultMessage: "Guernsey",
      description: { text: "Country name" },
    }),
    "+44 7839",
  ],
  [
    strictLocalize({
      id: "nGDB07",
      defaultMessage: "Guernsey",
      description: { text: "Country name" },
    }),
    "+44 7911",
  ],
  [
    strictLocalize({
      id: "7zLoLT",
      defaultMessage: "Jersey",
      description: { text: "Country name" },
    }),
    "+44 1534",
  ],
  [
    strictLocalize({
      id: "8RDJ7o",
      defaultMessage: "Isle of Man",
      description: { text: "Country name" },
    }),
    "+44 1624",
  ],
  [
    strictLocalize({
      id: "8RDJ7o",
      defaultMessage: "Isle of Man",
      description: { text: "Country name" },
    }),
    "+44 7524",
  ],
  [
    strictLocalize({
      id: "8RDJ7o",
      defaultMessage: "Isle of Man",
      description: { text: "Country name" },
    }),
    "+44 7624",
  ],
  [
    strictLocalize({
      id: "8RDJ7o",
      defaultMessage: "Isle of Man",
      description: { text: "Country name" },
    }),
    "+44 7924",
  ],
  [
    strictLocalize({
      id: "AlL8gr",
      defaultMessage: "Jan Mayen",
      description: { text: "Country name" },
    }),
    "+47 79",
  ],
  [
    strictLocalize({
      id: "CuF5W2",
      defaultMessage: "Svalbard",
      description: { text: "Country name" },
    }),
    "+47 79",
  ],
  [
    strictLocalize({
      id: "m+SGaR",
      defaultMessage: "Poland",
      description: { text: "Country name" },
    }),
    "+48",
  ],
  [
    strictLocalize({
      id: "KryyFA",
      defaultMessage: "Falkland Islands",
      description: { text: "Country name" },
    }),
    "+500",
  ],
  [
    strictLocalize({
      id: "sK4vNT",
      defaultMessage: "South Georgia and the South Sandwich Islands",
      description: { text: "Country name" },
    }),
    "+500",
  ],
  [
    strictLocalize({
      id: "v/jwm9",
      defaultMessage: "Belize",
      description: { text: "Country name" },
    }),
    "+501",
  ],
  [
    strictLocalize({
      id: "FRrzA5",
      defaultMessage: "Guatemala",
      description: { text: "Country name" },
    }),
    "+502",
  ],
  [
    strictLocalize({
      id: "8VddLG",
      defaultMessage: "El Salvador",
      description: { text: "Country name" },
    }),
    "+503",
  ],
  [
    strictLocalize({
      id: "OoooPP",
      defaultMessage: "Honduras",
      description: { text: "Country name" },
    }),
    "+504",
  ],
  [
    strictLocalize({
      id: "at1lyZ",
      defaultMessage: "Nicaragua",
      description: { text: "Country name" },
    }),
    "+505",
  ],
  [
    strictLocalize({
      id: "Bg3Smm",
      defaultMessage: "Costa Rica",
      description: { text: "Country name" },
    }),
    "+506",
  ],
  [
    strictLocalize({
      id: "gK11Ha",
      defaultMessage: "Panama",
      description: { text: "Country name" },
    }),
    "+507",
  ],
  [
    strictLocalize({
      id: "htE+3A",
      defaultMessage: "Saint Pierre and Miquelon",
      description: { text: "Country name" },
    }),
    "+508",
  ],
  [
    strictLocalize({
      id: "LGCnXC",
      defaultMessage: "Haiti",
      description: { text: "Country name" },
    }),
    "+509",
  ],
  [
    strictLocalize({
      id: "IMBhgU",
      defaultMessage: "Peru",
      description: { text: "Country name" },
    }),
    "+51",
  ],
  [
    strictLocalize({
      id: "x+z7J9",
      defaultMessage: "Mexico",
      description: { text: "Country name" },
    }),
    "+52",
  ],
  [
    strictLocalize({
      id: "O4o1xo",
      defaultMessage: "Cuba",
      description: { text: "Country name" },
    }),
    "+53",
  ],
  [
    strictLocalize({
      id: "DHx4Fi",
      defaultMessage: "Argentina",
      description: { text: "Country name" },
    }),
    "+54",
  ],
  [
    strictLocalize({
      id: "Na6Zk+",
      defaultMessage: "Brazil",
      description: { text: "Country name" },
    }),
    "+55",
  ],
  [
    strictLocalize({
      id: "6YvCgQ",
      defaultMessage: "Chile",
      description: { text: "Country name" },
    }),
    "+56",
  ],
  [
    strictLocalize({
      id: "rn4gip",
      defaultMessage: "Easter Island",
      description: { text: "Country name" },
    }),
    "+56",
  ],
  [
    strictLocalize({
      id: "NvgMG6",
      defaultMessage: "Colombia",
      description: { text: "Country name" },
    }),
    "+57",
  ],
  [
    strictLocalize({
      id: "cskFJu",
      defaultMessage: "Venezuela",
      description: { text: "Country name" },
    }),
    "+58",
  ],
  [
    strictLocalize({
      id: "2hFu0m",
      defaultMessage: "Guadeloupe",
      description: { text: "Country name" },
    }),
    "+590",
  ],
  [
    strictLocalize({
      id: "Y0WjYs",
      defaultMessage: "Saint Barthélemy",
      description: { text: "Country name" },
    }),
    "+590",
  ],
  [
    strictLocalize({
      id: "Y51OlN",
      defaultMessage: "Saint Martin (France)",
      description: { text: "Country name" },
    }),
    "+590",
  ],
  [
    strictLocalize({
      id: "0u8Xe7",
      defaultMessage: "Bolivia",
      description: { text: "Country name" },
    }),
    "+591",
  ],
  [
    strictLocalize({
      id: "GXyMEZ",
      defaultMessage: "Guyana",
      description: { text: "Country name" },
    }),
    "+592",
  ],
  [
    strictLocalize({
      id: "wRGLHE",
      defaultMessage: "Ecuador",
      description: { text: "Country name" },
    }),
    "+593",
  ],
  [
    strictLocalize({
      id: "gtgEUW",
      defaultMessage: "French Guiana",
      description: { text: "Country name" },
    }),
    "+594",
  ],
  [
    strictLocalize({
      id: "tbvLcT",
      defaultMessage: "Paraguay",
      description: { text: "Country name" },
    }),
    "+595",
  ],
  [
    strictLocalize({
      id: "rjSf4w",
      defaultMessage: "French Antilles",
      description: { text: "Country name" },
    }),
    "+596",
  ],
  [
    strictLocalize({
      id: "YNK13S",
      defaultMessage: "Martinique",
      description: { text: "Country name" },
    }),
    "+596",
  ],
  [
    strictLocalize({
      id: "xNQroC",
      defaultMessage: "Suriname",
      description: { text: "Country name" },
    }),
    "+597",
  ],
  [
    strictLocalize({
      id: "sJmhho",
      defaultMessage: "Uruguay",
      description: { text: "Country name" },
    }),
    "+598",
  ],
  [
    strictLocalize({
      id: "C4f1kM",
      defaultMessage: "Sint Eustatius",
      description: { text: "Country name" },
    }),
    "+599 3",
  ],
  [
    strictLocalize({
      id: "0FhLbd",
      defaultMessage: "Caribbean Netherlands",
      description: { text: "Country name" },
    }),
    "+599 3",
  ],
  [
    strictLocalize({
      id: "0FhLbd",
      defaultMessage: "Caribbean Netherlands",
      description: { text: "Country name" },
    }),
    "+599 4",
  ],
  [
    strictLocalize({
      id: "0FhLbd",
      defaultMessage: "Caribbean Netherlands",
      description: { text: "Country name" },
    }),
    "+599 7",
  ],
  [
    strictLocalize({
      id: "Adw1RS",
      defaultMessage: "Saba",
      description: { text: "Country name" },
    }),
    "+599 4",
  ],
  [
    strictLocalize({
      id: "moIRHO",
      defaultMessage: "Bonaire",
      description: { text: "Country name" },
    }),
    "+599 7",
  ],
  [
    strictLocalize({
      id: "56tgoN",
      defaultMessage: "Curaçao",
      description: { text: "Country name" },
    }),
    "+599 9",
  ],
  [
    strictLocalize({
      id: "jR4Ryv",
      defaultMessage: "Malaysia",
      description: { text: "Country name" },
    }),
    "+60",
  ],
  [
    strictLocalize({
      id: "ooF4Qj",
      defaultMessage: "Cocos (Keeling) Islands",
      description: { text: "Country name" },
    }),
    "+61 89162",
  ],
  [
    strictLocalize({
      id: "1N7EQj",
      defaultMessage: "Christmas Island",
      description: { text: "Country name" },
    }),
    "+61 89164",
  ],
  [
    strictLocalize({
      id: "mFgQr6",
      defaultMessage: "Indonesia",
      description: { text: "Country name" },
    }),
    "+62",
  ],
  [
    strictLocalize({
      id: "cPusxn",
      defaultMessage: "Philippines",
      description: { text: "Country name" },
    }),
    "+63",
  ],
  [
    strictLocalize({
      id: "6B2rIJ",
      defaultMessage: "Chatham Island, New Zealand",
      description: { text: "Country name" },
    }),
    "+64",
  ],
  [
    strictLocalize({
      id: "xUHU/X",
      defaultMessage: "New Zealand",
      description: { text: "Country name" },
    }),
    "+64",
  ],
  [
    strictLocalize({
      id: "HKZOm7",
      defaultMessage: "Pitcairn Islands",
      description: { text: "Country name" },
    }),
    "+64",
  ],
  [
    strictLocalize({
      id: "cBofoc",
      defaultMessage: "Singapore",
      description: { text: "Country name" },
    }),
    "+65",
  ],
  [
    strictLocalize({
      id: "T76v70",
      defaultMessage: "Thailand",
      description: { text: "Country name" },
    }),
    "+66",
  ],
  [
    strictLocalize({
      id: "j4hX3X",
      defaultMessage: "East Timor",
      description: { text: "Country name" },
    }),
    "+670",
  ],
  [
    strictLocalize({
      id: "9e0DW1",
      defaultMessage: "Australian External Territories",
      description: { text: "Country name" },
    }),
    "+672",
  ],
  [
    strictLocalize({
      id: "BjGRer",
      defaultMessage: "Australian Antarctic Territory",
      description: { text: "Country name" },
    }),
    "+672 1",
  ],
  [
    strictLocalize({
      id: "gGE+Mn",
      defaultMessage: "Norfolk Island",
      description: { text: "Country name" },
    }),
    "+672 3",
  ],
  [
    strictLocalize({
      id: "q0Yu0p",
      defaultMessage: "Brunei Darussalam",
      description: { text: "Country name" },
    }),
    "+673",
  ],
  [
    strictLocalize({
      id: "FGevaQ",
      defaultMessage: "Nauru",
      description: { text: "Country name" },
    }),
    "+674",
  ],
  [
    strictLocalize({
      id: "YVDmvP",
      defaultMessage: "Papua New Guinea",
      description: { text: "Country name" },
    }),
    "+675",
  ],
  [
    strictLocalize({
      id: "q7uDLw",
      defaultMessage: "Tonga",
      description: { text: "Country name" },
    }),
    "+676",
  ],
  [
    strictLocalize({
      id: "bc2C7j",
      defaultMessage: "Solomon Islands",
      description: { text: "Country name" },
    }),
    "+677",
  ],
  [
    strictLocalize({
      id: "ZBYSI6",
      defaultMessage: "Vanuatu",
      description: { text: "Country name" },
    }),
    "+678",
  ],
  [
    strictLocalize({
      id: "5OViyD",
      defaultMessage: "Fiji",
      description: { text: "Country name" },
    }),
    "+679",
  ],
  [
    strictLocalize({
      id: "CUFYgB",
      defaultMessage: "Palau",
      description: { text: "Country name" },
    }),
    "+680",
  ],
  [
    strictLocalize({
      id: "Dxrw0t",
      defaultMessage: "Wallis and Futuna",
      description: { text: "Country name" },
    }),
    "+681",
  ],
  [
    strictLocalize({
      id: "icHAs2",
      defaultMessage: "Cook Islands",
      description: { text: "Country name" },
    }),
    "+682",
  ],
  [
    strictLocalize({
      id: "D0dDRz",
      defaultMessage: "Niue",
      description: { text: "Country name" },
    }),
    "+683",
  ],
  [
    strictLocalize({
      id: "PqB5H7",
      defaultMessage: "Samoa",
      description: { text: "Country name" },
    }),
    "+685",
  ],
  [
    strictLocalize({
      id: "nBiHtL",
      defaultMessage: "Kiribati",
      description: { text: "Country name" },
    }),
    "+686",
  ],
  [
    strictLocalize({
      id: "TPATKd",
      defaultMessage: "New Caledonia",
      description: { text: "Country name" },
    }),
    "+687",
  ],
  [
    strictLocalize({
      id: "k+hXba",
      defaultMessage: "Tuvalu",
      description: { text: "Country name" },
    }),
    "+688",
  ],
  [
    strictLocalize({
      id: "eY8VTj",
      defaultMessage: "French Polynesia",
      description: { text: "Country name" },
    }),
    "+689",
  ],
  [
    strictLocalize({
      id: "mNpbEF",
      defaultMessage: "Tokelau",
      description: { text: "Country name" },
    }),
    "+690",
  ],
  [
    strictLocalize({
      id: "z9msz0",
      defaultMessage: "Micronesia, Federated States of",
      description: { text: "Country name" },
    }),
    "+691",
  ],
  [
    strictLocalize({
      id: "b5nDgZ",
      defaultMessage: "Marshall Islands",
      description: { text: "Country name" },
    }),
    "+692",
  ],
  [
    strictLocalize({
      id: "jjsCdD",
      defaultMessage: "Kazakhstan",
      description: { text: "Country name" },
    }),
    "+7 6",
  ],
  [
    strictLocalize({
      id: "jjsCdD",
      defaultMessage: "Kazakhstan",
      description: { text: "Country name" },
    }),
    "+7 7",
  ],
  [
    strictLocalize({
      id: "Jx+c2V",
      defaultMessage: "Russia",
      description: { text: "Country name" },
    }),
    "+7",
  ],
  [
    strictLocalize({
      id: "17CHI9",
      defaultMessage: "International Freephone Service (UIFN)",
      description: { text: "Country name" },
    }),
    "+800",
  ],
  [
    strictLocalize({
      id: "c8RfkX",
      defaultMessage: "International Shared Cost Service (ISCS)",
      description: { text: "Country name" },
    }),
    "+808",
  ],
  [
    strictLocalize({
      id: "4eo8lD",
      defaultMessage: "Japan",
      description: { text: "Country name" },
    }),
    "+81",
  ],
  [
    strictLocalize({
      id: "hlS5/o",
      defaultMessage: "Korea, South",
      description: { text: "Country name" },
    }),
    "+82",
  ],
  [
    strictLocalize({
      id: "hVDqQx",
      defaultMessage: "Vietnam",
      description: { text: "Country name" },
    }),
    "+84",
  ],
  [
    strictLocalize({
      id: "WYIJ4z",
      defaultMessage: "Korea, North",
      description: { text: "Country name" },
    }),
    "+850",
  ],
  [
    strictLocalize({
      id: "+1B2VQ",
      defaultMessage: "Hong Kong",
      description: { text: "Country name" },
    }),
    "+852",
  ],
  [
    strictLocalize({
      id: "w4p7NU",
      defaultMessage: "Macau",
      description: { text: "Country name" },
    }),
    "+853",
  ],
  [
    strictLocalize({
      id: "UWqYoK",
      defaultMessage: "Cambodia",
      description: { text: "Country name" },
    }),
    "+855",
  ],
  [
    strictLocalize({
      id: "170HHi",
      defaultMessage: "Laos",
      description: { text: "Country name" },
    }),
    "+856",
  ],
  [
    strictLocalize({
      id: "Ghjs7e",
      defaultMessage: "China",
      description: { text: "Country name" },
    }),
    "+86",
  ],
  [
    strictLocalize({
      id: "gAihDj",
      defaultMessage: "Inmarsat SNAC",
      description: { text: "Country name" },
    }),
    "+870",
  ],
  [
    strictLocalize({
      id: "fLpWRH",
      defaultMessage: "Universal Personal Telecommunications (UPT)",
      description: { text: "Country name" },
    }),
    "+878",
  ],
  [
    strictLocalize({
      id: "wGr0qF",
      defaultMessage: "Bangladesh",
      description: { text: "Country name" },
    }),
    "+880",
  ],
  [
    strictLocalize({
      id: "K6BEN9",
      defaultMessage: "Global Mobile Satellite System (GMSS)",
      description: { text: "Country name" },
    }),
    "+881",
  ],
  [
    strictLocalize({
      id: "iSvOVn",
      defaultMessage: "ICO Global (Mobile Satellite Service)",
      description: { text: "Country name" },
    }),
    "+881 0",
  ],
  [
    strictLocalize({
      id: "iSvOVn",
      defaultMessage: "ICO Global (Mobile Satellite Service)",
      description: { text: "Country name" },
    }),
    "+881 1",
  ],
  [
    strictLocalize({
      id: "EeF9ys",
      defaultMessage: "Ellipso (Mobile Satellite service)",
      description: { text: "Country name" },
    }),
    "+881 2",
  ],
  [
    strictLocalize({
      id: "EeF9ys",
      defaultMessage: "Ellipso (Mobile Satellite service) ",
      description: { text: "Country name" },
    }),
    "+881 3",
  ],
  [
    strictLocalize({
      id: "xyAL/C",
      defaultMessage: "Iridium (Mobile Satellite service)",
      description: { text: "Country name" },
    }),
    "+881 6",
  ],
  [
    strictLocalize({
      id: "xyAL/C",
      defaultMessage: "Iridium (Mobile Satellite service) ",
      description: { text: "Country name" },
    }),
    "+881 7",
  ],
  [
    strictLocalize({
      id: "HQsHyU",
      defaultMessage: "Globalstar (Mobile Satellite Service)",
      description: { text: "Country name" },
    }),
    "+881 8",
  ],
  [
    strictLocalize({
      id: "HQsHyU",
      defaultMessage: "Globalstar (Mobile Satellite Service)",
      description: { text: "Country name" },
    }),
    "+881 9",
  ],
  [
    strictLocalize({
      id: "W1lomw",
      defaultMessage: "EMSAT (Mobile Satellite service)",
      description: { text: "Country name" },
    }),
    "+882 13",
  ],
  [
    strictLocalize({
      id: "AJR1ta",
      defaultMessage: "Thuraya (Mobile Satellite service)",
      description: { text: "Country name" },
    }),
    "+882 16",
  ],
  [
    strictLocalize({
      id: "RXrsB/",
      defaultMessage: "International Networks",
      description: { text: "Country name" },
    }),
    "+882",
  ],
  [
    strictLocalize({
      id: "RXrsB/",
      defaultMessage: "International Networks",
      description: { text: "Country name" },
    }),
    "+883",
  ],
  [
    strictLocalize({
      id: "UcF9Qa",
      defaultMessage: "Taiwan",
      description: { text: "Country name" },
    }),
    "+886",
  ],
  [
    strictLocalize({
      id: "gwiBbk",
      defaultMessage: "Telecommunications for Disaster Relief by OCHA",
      description: { text: "Country name" },
    }),
    "+888",
  ],
  [
    strictLocalize({
      id: "R/DrWa",
      defaultMessage: "Turkey",
      description: { text: "Country name" },
    }),
    "+90",
  ],
  [
    strictLocalize({
      id: "PZAGRr",
      defaultMessage: "Northern Cyprus",
      description: { text: "Country name" },
    }),
    "+90 392",
  ],
  [
    strictLocalize({
      id: "OuqHJV",
      defaultMessage: "India",
      description: { text: "Country name" },
    }),
    "+91",
  ],
  [
    strictLocalize({
      id: "wQwZnm",
      defaultMessage: "Pakistan",
      description: { text: "Country name" },
    }),
    "+92",
  ],
  [
    strictLocalize({
      id: "QBh3su",
      defaultMessage: "Afghanistan",
      description: { text: "Country name" },
    }),
    "+93",
  ],
  [
    strictLocalize({
      id: "Ug8mB3",
      defaultMessage: "Sri Lanka",
      description: { text: "Country name" },
    }),
    "+94",
  ],
  [
    strictLocalize({
      id: "6o298C",
      defaultMessage: "Myanmar",
      description: { text: "Country name" },
    }),
    "+95",
  ],
  [
    strictLocalize({
      id: "t+lxSY",
      defaultMessage: "Maldives",
      description: { text: "Country name" },
    }),
    "+960",
  ],
  [
    strictLocalize({
      id: "N5tzBg",
      defaultMessage: "Lebanon",
      description: { text: "Country name" },
    }),
    "+961",
  ],
  [
    strictLocalize({
      id: "6G86jj",
      defaultMessage: "Jordan",
      description: { text: "Country name" },
    }),
    "+962",
  ],
  [
    strictLocalize({
      id: "v2mAHZ",
      defaultMessage: "Syria",
      description: { text: "Country name" },
    }),
    "+963",
  ],
  [
    strictLocalize({
      id: "8NSGvE",
      defaultMessage: "Iraq",
      description: { text: "Country name" },
    }),
    "+964",
  ],
  [
    strictLocalize({
      id: "BwYt5E",
      defaultMessage: "Kuwait",
      description: { text: "Country name" },
    }),
    "+965",
  ],
  [
    strictLocalize({
      id: "MLFihM",
      defaultMessage: "Saudi Arabia",
      description: { text: "Country name" },
    }),
    "+966",
  ],
  [
    strictLocalize({
      id: "a5cHe8",
      defaultMessage: "Yemen",
      description: { text: "Country name" },
    }),
    "+967",
  ],
  [
    strictLocalize({
      id: "SKo0T4",
      defaultMessage: "Oman",
      description: { text: "Country name" },
    }),
    "+968",
  ],
  [
    strictLocalize({
      id: "+tBj2E",
      defaultMessage: "Palestine, State of",
      description: { text: "Country name" },
    }),
    "+970",
  ],
  [
    strictLocalize({
      id: "JJ+wjh",
      defaultMessage: "United Arab Emirates",
      description: { text: "Country name" },
    }),
    "+971",
  ],
  [
    strictLocalize({
      id: "0oDO5k",
      defaultMessage: "Israel",
      description: { text: "Country name" },
    }),
    "+972",
  ],
  [
    strictLocalize({
      id: "LA1YkY",
      defaultMessage: "Bahrain",
      description: { text: "Country name" },
    }),
    "+973",
  ],
  [
    strictLocalize({
      id: "foR1pI",
      defaultMessage: "Qatar",
      description: { text: "Country name" },
    }),
    "+974",
  ],
  [
    strictLocalize({
      id: "UiiUyp",
      defaultMessage: "Bhutan",
      description: { text: "Country name" },
    }),
    "+975",
  ],
  [
    strictLocalize({
      id: "vsuVAf",
      defaultMessage: "Mongolia",
      description: { text: "Country name" },
    }),
    "+976",
  ],
  [
    strictLocalize({
      id: "kX6yvj",
      defaultMessage: "Nepal",
      description: { text: "Country name" },
    }),
    "+977",
  ],
  [
    strictLocalize({
      id: "IJQ1A1",
      defaultMessage: "International Premium Rate Service",
      description: { text: "Country name" },
    }),
    "+979",
  ],
  [
    strictLocalize({
      id: "hRhjpL",
      defaultMessage: "Iran",
      description: { text: "Country name" },
    }),
    "+98",
  ],
  [
    strictLocalize({
      id: "Hr++1T",
      defaultMessage: "Tajikistan",
      description: { text: "Country name" },
    }),
    "+992",
  ],
  [
    strictLocalize({
      id: "n8EqN4",
      defaultMessage: "Turkmenistan",
      description: { text: "Country name" },
    }),
    "+993",
  ],
  [
    strictLocalize({
      id: "I+AeNv",
      defaultMessage: "Azerbaijan",
      description: { text: "Country name" },
    }),
    "+994",
  ],
  [
    strictLocalize({
      id: "WH7zS6",
      defaultMessage: "Georgia",
      description: { text: "Country name" },
    }),
    "+995",
  ],
  [
    strictLocalize({
      id: "oMk2RX",
      defaultMessage: "South Ossetia",
      description: { text: "Country name" },
    }),
    "+995 34",
  ],
  [
    strictLocalize({
      id: "S1SlKr",
      defaultMessage: "Kyrgyzstan",
      description: { text: "Country name" },
    }),
    "+996",
  ],
  [
    strictLocalize({
      id: "ZMi/t6",
      defaultMessage: "Uzbekistan",
      description: { text: "Country name" },
    }),
    "+998",
  ],
];
